// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__LaLIy","inputWrap":"CustomTip_inputWrap__3icj-"};